//https://github.com/lekoala/bootstrap5-autocomplete?tab=readme-ov-file
// import Autocomplete from "./autocomplete.js";
// Autocomplete.init();

/**
 * Generic Preference Selector JavaScript
 * Handles swapping between preferred and alternative form fields
 */
// Main initialization function
function initializePreferenceSelector() {
  // Initialize tooltips if Bootstrap is available
  if (typeof bootstrap !== "undefined" && bootstrap.Tooltip) {
    initializeTooltips();
  }

  // Initialize event listeners for make-preferred buttons
  initializeMakePreferredButtons();
}

// Initialize Bootstrap tooltips
function initializeTooltips() {
  try {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]',
    );
    if (tooltipTriggerList.length > 0) {
      tooltipTriggerList.forEach(function (tooltipTriggerEl) {
        new bootstrap.Tooltip(tooltipTriggerEl);
      });
    }
  } catch (error) {
    console.warn("Bootstrap tooltips initialization failed:", error);
  }
}

// Initialize make-preferred button event listeners
function initializeMakePreferredButtons() {
  const makePreferredButtons = document.querySelectorAll(".make-preferred-btn");

  makePreferredButtons.forEach((button) => {
    button.addEventListener("click", function () {
      makePreferred(this);
    });
  });
}

// Main function to handle making an alternative field preferred
function makePreferred(clickedButton) {
  if (!clickedButton) {
    console.warn("makePreferred called without valid button element");
    return;
  }

  // Find the group this button belongs to
  const group = clickedButton.closest(".preference-selector-group");
  if (!group) {
    console.warn("Could not find preference selector group for button");
    return;
  }

  const preferredField = group.querySelector(".preferred-field");
  const alternativeField = clickedButton
    .closest(".col-form-data")
    ?.querySelector(".alternative-field");

  if (!preferredField || !alternativeField) {
    console.warn("Could not find required fields for preference swap");
    return;
  }

  // Only swap if the alternative has a value
  if (alternativeField.value && alternativeField.value.trim() !== "") {
    // Store the current preferred value
    const currentPreferred = preferredField.value;

    // Set the alternative's value as the new preferred
    preferredField.value = alternativeField.value;

    // Set the old preferred value to the alternative (if it had a value)
    alternativeField.value = currentPreferred;

    // Add visual feedback
    showSwapFeedback(clickedButton);
  } else {
    // Show warning if trying to make empty field preferred
    showWarning(
      "Selecteer/vul eerst een waarde in voordat je deze als voorkeur instelt.",
      group,
    );
  }
}

// Show visual feedback when swap occurs
function showSwapFeedback(button) {
  if (!button) return;

  const icon = button.querySelector("i");
  if (!icon) return;

  // Temporarily change to filled star
  icon.classList.remove("bi-star");
  icon.classList.add("bi-star-fill");
  button.style.color = "#ffc107";

  // Reset after animation
  setTimeout(() => {
    icon.classList.remove("bi-star-fill");
    icon.classList.add("bi-star");
    button.style.color = "";
  }, 1000);
}

// Show warning message
function showWarning(message, targetGroup) {
  if (!targetGroup || !message) return;

  // Remove existing warnings first
  const existingWarnings = targetGroup.querySelectorAll(".alert-warning");
  existingWarnings.forEach((warning) => warning.remove());

  const alertDiv = document.createElement("div");
  alertDiv.className = "alert alert-warning alert-dismissible fade show mt-2";
  alertDiv.innerHTML = `
        ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    `;

  targetGroup.appendChild(alertDiv);

  // Auto-remove after 3 seconds
  setTimeout(() => {
    if (alertDiv.parentNode) {
      alertDiv.remove();
    }
  }, 3000);
}

// Helper function to get all form data (useful for form submission)
function getAllFormData() {
  const allGroups = document.querySelectorAll(".preference-selector-group");
  const formData = {};

  allGroups.forEach((group) => {
    const groupName = group.dataset.group;
    if (!groupName) return;

    const preferredField = group.querySelector(".preferred-field");
    const alternativeFields = Array.from(
      group.querySelectorAll(".alternative-field"),
    );

    formData[groupName] = {
      preferred: preferredField ? preferredField.value : "",
      alternatives: alternativeFields.map((field) => field.value),
    };
  });

  return formData;
}

// Public API for manual initialization (if needed)
// window.PreferenceSelector = {
// init: initializePreferenceSelector,
// makePreferred: makePreferred,
// getAllFormData: getAllFormData,
// };

// Auto-initialize when DOM is ready
// if (document.readyState === "loading") {
// document.addEventListener("DOMContentLoaded", initializePreferenceSelector);
// } else {
// // DOM is already loaded
// initializePreferenceSelector();
// }

export { initializePreferenceSelector };
